import React from 'react';
import { withStyles } from '@material-ui/core';

import styles from './style';
import RoomItem from './RoomItem';
import Box from '../../atomic/Box';
import Typography from '../../atomic/Typography';
import { compareAlphabetically } from '../../../utils/strings';
import { getRoomId, getRoomName, getFloorLabel } from '../../../utils/rooms';
import useDesktop from '../../../hooks/useDesktop';

const FloorGroup = ({
  floor,
  rooms,
  searchQuery,
  onRoomUpdated,
  enableImageUpload,
}) => {
  const isDesktop = useDesktop();

  const sortedRooms = (rooms || []).sort((a, b) =>
    compareAlphabetically(getRoomName(a), getRoomName(b))
  );

  return (
    <Box>
      <Box mb={2} ml={!isDesktop ? 2 : 0}>
        <Typography variant="h2">{getFloorLabel(floor)}</Typography>
      </Box>

      <Box ml={isDesktop ? -2 : 0}>
        <div className="flex flex-wrap overflow-hidden">
          {sortedRooms.map((room) => (
            <RoomItem
              room={room}
              searchQuery={searchQuery}
              onRoomUpdated={onRoomUpdated}
              key={`room-item-${getRoomId(room)}`}
              enableImageUpload={enableImageUpload}
            />
          ))}
        </div>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(FloorGroup);
